import { trackInclick, } from '@slickdeals/web-instrumentation';
const defaultGetDealData = (card) => {
    var _a;
    const dealElement = card.querySelector('[data-thread-id]') ||
        (card.hasAttribute('data-thread-id') ? card : null);
    const uniqueId = dealElement === null || dealElement === void 0 ? void 0 : dealElement.getAttribute('data-thread-id');
    if (!dealElement || !uniqueId) {
        return null;
    }
    return {
        uniqueId,
        dealTitle: ((_a = dealElement.textContent) === null || _a === void 0 ? void 0 : _a.trim()) || '',
        isExpired: dealElement.getAttribute('data-is-expired') === '1',
        listPriceText: dealElement.getAttribute('data-list-price') || '',
        finalPriceText: dealElement.getAttribute('data-final-price') || '',
    };
};
export const initInclickTracking = (root, cardSelector, config) => {
    const getDealData = config.getDealData || defaultGetDealData;
    const handleInclickEvent = (event) => {
        var _a;
        if (!(event.target instanceof Element)) {
            return;
        }
        const link = event.target.closest('a');
        if (!link) {
            return;
        }
        const url = new URL(link.href, window.location.origin);
        if (!url.pathname.startsWith('/f/') && !url.pathname.startsWith('/e/')) {
            return;
        }
        const card = link.closest(cardSelector);
        if (!card) {
            return;
        }
        const deal = getDealData(card, link);
        if (!deal) {
            return;
        }
        const actionSource = config.getActionSource(link, card);
        if (!actionSource) {
            return;
        }
        const allCards = root.querySelectorAll(cardSelector);
        const index = Array.from(allCards).indexOf(card);
        const data = {
            url: link.href,
            dealIndex: index >= 0 ? index : null,
            page: Number((_a = new URLSearchParams(window.location.search).get('page')) !== null && _a !== void 0 ? _a : 1),
            containerName: config.containerName,
            containerId: config.containerId || '',
            containerType: config.containerType,
            currentUrl: window.location.href,
            currentPageTitle: document.title,
            actionSource,
            contentLayoutRender: config.contentLayoutRender,
        };
        trackInclick(data, deal);
    };
    root.addEventListener('click', handleInclickEvent);
    root.addEventListener('auxclick', (event) => {
        if (event.button !== 1) {
            return;
        }
        handleInclickEvent(event);
    });
};
